import { useCustomAlert } from "../alerts";
import useFetchAndTrace from "../fetchWithTrace";
import { useCallback } from "react";
import { DownloadableFileResponse } from "../uploadToS3";
import settings from "../../../constants/settings";

export default function useDownloadInStockPartsList() {
  const customAlert = useCustomAlert();
  const fetchAndTrace = useFetchAndTrace();

  const errorHandler = useCallback(() => {
    customAlert("Failed to get in stock parts list");
  }, [customAlert]);

  return useCallback(() => {
    const simpleSuccessHandler = async (response: Response) => {
      if (!response.ok) {
        throw new Error("Failed to get in stock parts list");
      }
      const downloadableFile =
        (await response.json()) as DownloadableFileResponse;
      window.open(downloadableFile.link, "_blank");
    };

    void fetchAndTrace(
      `${settings.api_url}/parts/in-stock-parts-list`,
      simpleSuccessHandler,
      errorHandler,
    );
  }, [errorHandler, fetchAndTrace]);
}
